export enum ProjectMetadata {
    location = 'location',
    surface = 'surface',
    duration = 'duration',
    year = 'year',
}